fragment flexibleDownload on flexibleSections_download_BlockType {
    assetRelation {
        url
    }
    label: plaintext
    color: colorDropdown
}
